// src/services/EventService.js
import { getUUID } from '../utils/helpers.js';

export class EventService {
  constructor() {
    this.connections = new Map(); // Store connections by company number
    this.selectedCompany = null;
  }

  setSelectedCompany(companyNumber) {
    this.selectedCompany = companyNumber;
    // Optionally ensure connection exists for this company
    this.getConnection(companyNumber);
  }

  getConnection(companyNumber) {
    const idStr = 'clientBrowserIdCompany' + companyNumber;

    this.clientBrowserId = localStorage.getItem(idStr);

    if (!this.clientBrowserId) {
      this.clientBrowserId = getUUID();
      localStorage.setItem(idStr, this.clientBrowserId);
    }

    if (!this.connections.has(companyNumber)) {
      const events = new EventSource(`${process.env.VUE_APP_THIS_SERVER}/portaldb/db/events/${this.clientBrowserId}/${companyNumber}`);
      this.connections.set(companyNumber, events);
    }
    return this.connections.get(companyNumber);
  }

  disconnect(companyNumber) {
    const events = this.connections.get(companyNumber);
    if (events) {
      events.close();
      this.connections.delete(companyNumber);
    }
  }

  disconnectAll() {
    for (const [companyNumber] of this.connections) {
      this.disconnect(companyNumber);
    }
  }
}

export const eventService = new EventService();

